import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_DOCUMENTS: {
    url: "vervanger/documentList",
    method: "get",
  },

  DELETE_DOCUMENT: {
    url: "vervanger/deleteDocument",
    method: "get",
  },

  UPDATE_REMINDER_DATE: {
    url: "update-herinneringsdatum",
    method: "post",
  },

  DOWNLOAD_DOCUMENT: {
    url: "document",
    method: "get",
  },

};

export const useDocuments = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_DOCUMENTS);

export const useDeleteDocument = (docId) =>
  useApiFetcherSWR(
    docId
      ? {
        ...API_ENDPOINT.DELETE_DOCUMENT,
        params: {
          id: docId,
        },
        url: `${API_ENDPOINT.DELETE_DOCUMENT.url}/${docId}`,
      }
      : null
  );

export const useUpdateReminderDate = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_REMINDER_DATE);

export const useDownloadDocument = () =>
  useApiFetcherSWR(API_ENDPOINT.DOWNLOAD_DOCUMENT.url);